export const API_URL = process.env.REACT_APP_API_URL;

export function getWithdrawUrl(status, startDate, endDate) {
  let curUrl = API_URL + "/requests?mode=view";
  if (status) {
    curUrl = curUrl + "&status=" + status;
  }
  if (startDate) {
    curUrl = curUrl + "&startDate=" + startDate;
  }
  if (endDate) {
    curUrl = curUrl + "&endDate=" + endDate;
  }
  return curUrl;
}

export function getWebhookSendUrl(id) {
  return API_URL + `/withdraw/hook/${id}`;
}

export function restartTransactionUrl(id) {
  return API_URL + `/withdraw/reinstant/${id}`;
}
